import gql from 'graphql-tag';

const clientWorkspaceLeadFragment = gql`
  fragment ClientWorkspaceLeadFragment on ClientWorkspaceLead {
    _id
    leadNumber
    managerInfo {
      _id
      dbId
      firstName
      lastName
      displayName
    }
    sourcePlatformNickname
    company
    companyTitle
    platformCompanyId
    sourceType
    sourcePlatform
    sourceId
    referralCode
    referrerId
    referrerName
    lmsStudentId
    firstName
    lastName
    paymentSum
    paymentRemainder
    fullPaymentAt
    bonusAvailableAt
    bonusPaidAt
    phone
    email
    age
    dbId
    courseType
    productId
    productSource
    products {
      productId
      productTitle
      productType
      priceOptionId
      priceTitle
      price
      discountPercent
      discountedPrice
      currency
      bonusValue
      bonusPaymentType
      rewardValue
      paymentType
      referralCode
      referralLink
      isActive
    }
    status
    managerId
    signedForTrial
    trialDate
    trialResult
    lessonOneDate
    lessonOneResult
    paymentStatus
    paymentSum
    currency
    notes
    nextContactDate
    createdAt
    updatedAt
    projection {
      lmsStudentId
      firstName
      lastName
      phoneMasked
      emailMasked
      age
      studentStatus
      currentCourseId
      currentCourseTitle
      teacherId
      teacherName
      trialLessonAt
      lastPaymentStatus
      lastSyncedAt
    }
    referral {
      _id
      referrerId
      referralCode
      attributionType
      attributionStatus
      sourceType
      confirmedAt
      createdAt
    }
    reward {
      _id
      rewardType
      rewardValue
      currency
      triggerEvent
      status
      approvedBy
      approvedAt
      paidAt
      createdAt
    }
    funnelEvents {
      _id
      oldStatus
      newStatus
      changedBy
      changeSource
      comment
      createdAt
    }
  }
`;
export default clientWorkspaceLeadFragment;
